export default (id) => id.substr(id.indexOf('_') + 1, id.length);
